import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, LoadingSpinner } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import {
  BenefitGroupName,
  LunchSettings,
  MyChoiceDisclaimer,
  WarningProcessingOfEmployees,
  SelectBenefitsBar
} from '@epi-shared/components';
import {
  useGetBenefitGroupDetailsQuery,
  useGetDefaultBenefitGroupsSettingsQuery
} from '@epi-api/benefitGroups';
import { MyChoiceBenefitsList } from '@epi-shared/components/BenefitGroups/SettingsSections/MyChoiceBenefitsList/MyChoiceBenefitsList';
import { EditBenefitGroupForm } from '@epi-forms/BenefitGroup/EditBenefitGroupFrom';
import { useGetDetailsQuery } from '@epi-api/user';

import { AnnualLimitsGuideDot } from '../CreateBenefitGroup/components/AnnualLimitsGuideDot/AnnualLimitsGuideDot';

export const EditBenefitGroup = () => {
  const { t } = useTranslation();
  const { benefitGroupId } = useParams<{ benefitGroupId: string }>();
  const { data: benefitsDefaultSettings, isLoading: isDefaultsLoading } =
    useGetDefaultBenefitGroupsSettingsQuery();
  const { data: { isGroupManagementAllowed } = {} } = useGetDetailsQuery();
  const { data: groupDetails, isLoading: isGroupLoading } =
    useGetBenefitGroupDetailsQuery(benefitGroupId);

  if (isDefaultsLoading || isGroupLoading) {
    return <LoadingSpinner />;
  }
  if (!benefitsDefaultSettings?.contractedBenefits.length || !groupDetails) {
    return <div>{t('containers.benefit_groups.no_result')}</div>;
  }

  return (
    <EditBenefitGroupForm
      defaultSettings={benefitsDefaultSettings}
      groupDetails={groupDetails}
      groupId={benefitGroupId}
      isGroupManagementAllowed={isGroupManagementAllowed}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <WarningProcessingOfEmployees isHidden={isGroupManagementAllowed} />
        <BenefitGroupName />
        <SelectBenefitsBar
          contractedBenefits={benefitsDefaultSettings.contractedBenefits}
          disabled={!isGroupManagementAllowed}
        />
        <LunchSettings
          defaultSettings={benefitsDefaultSettings}
          isGroupManagementAllowed={isGroupManagementAllowed}
        />
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          gap={3}
          mt={1}
          position="relative"
        >
          <AnnualLimitsGuideDot />
          <MyChoiceBenefitsList
            contractedBenefits={benefitsDefaultSettings.contractedBenefits}
            companyMyChoiceEnabled={
              benefitsDefaultSettings.companyMyChoiceEnabled
            }
          />
        </Box>
        <MyChoiceDisclaimer benefitsDefaultSettings={benefitsDefaultSettings} />
      </Box>
    </EditBenefitGroupForm>
  );
};
